<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="import" @click="addVisible = true">入库</a-button>
				<!-- <a-button class="qinang-button-margin" icon="export" @click="tableOut">领用</a-button> -->
				<a-button class="qinang-button-margin" type="danger" icon="delete" @click="tableDelete">删除</a-button>
				<a-button icon="sync" @click="apiPfoutQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="领用记录查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId"  @change="facilitatorChange">
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">仓库名称：</div>
						<a-select v-model="query.pflibraryId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in pflibraryList" :key="index" :value="item.pflibraryId">{{item.pflibraryName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">产品名称：</div>
						<a-select v-model="query.productId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in productList" :key="index" :value="item.productId">{{item.productName}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">领取人：</div>
						<a-select v-model="query.optionStaffId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in staffList" :key="index" :value="item.staffId">{{item.staffName}}</a-select-option>
						</a-select>
					</div>
				</div>

				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiPfoutQueryList">查询</a-button>
					<a-button icon="redo" @click="resetting" style="margin-left: 14px;">重置</a-button>
				</div>
				
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="pfoutId" :loading="tableLoading" :pagination="false">
				<span slot="listingPrice" slot-scope="listingPrice">
					{{listingPrice.listingPrice / 100}}
				</span>
				<span slot="startSerial" slot-scope="startSerial">
					{{startSerial.prefixCharacter}}{{startSerial.startVerifyStateStr}}{{startSerial.startSerial}}{{startSerial.suffixCharacter}}
				</span>
				<span slot="endSerial" slot-scope="endSerial">
					{{endSerial.prefixCharacter}}{{endSerial.endVerifyStateStr}}{{endSerial.endSerial}}{{endSerial.suffixCharacter}}
				</span>
				<span slot="staffName" slot-scope="staffName">
					{{staffList.find(item => item.staffId === staffName.optionStaffId)?.staffName || '未指定'}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
				<span slot="operator" slot-scope="operator">
					<a-button type="link" @click="checkOutDetails(operator)">详情</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 100%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<div class="qa-table-item-3">
						<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
							<a-select v-model="addForm.facilitatorId" placeholder="请选择" @change="facilitatorChangeAdd">
								<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="仓库" has-feedback prop="pflibraryId">
							<a-select v-model="addForm.pflibraryId" placeholder="请选择" >
								<a-select-option v-for="(item,index) in pflibraryList2" :value="item.pflibraryId" :key="index">{{item.pflibraryName}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="票号规则" has-feedback prop="pfruleId">
							<a-select v-model="addForm.pfruleId" placeholder="请选择" @change="pfruleChangeAdd">
								<a-select-option v-for="(item,index) in pfruleList2" :value="item.pfruleId" :key="index">{{item.pfruleName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-2">
						<a-form-model-item label="产品名称" has-feedback prop="productId">
							<a-select v-model="addForm.productId" placeholder="请选择" @change="productChangeAdd">
								<a-select-option v-for="(item,index) in productList2" :value="item.productId" :key="index">{{item.productName}}</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item label="价格" has-feedback prop="priceId">
							<a-select v-model="addForm.priceId" placeholder="请选择">
								<a-select-option v-for="(item,index) in priceList" :value="item.priceId" :key="index">{{item.listingPrice / 100}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-3">
						<a-form-model-item label="起始票号" prop="startSerial">
							<a-input :addon-before="addForm.prefixCharacter" :addon-after="addForm.suffixCharacter" v-model="addForm.startSerial" @change="startSerialChangeAdd"/>
						</a-form-model-item>
						<a-form-model-item label="截止票号" has-feedback prop="endSerial">
							{{addForm.prefixCharacter}}{{addForm.endSerial}}{{addForm.suffixCharacter}}
						</a-form-model-item>
						<a-form-model-item label="数量" has-feedback prop="total">
							<a-input v-model="addForm.total" @change="totalChangeAdd"></a-input>
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk" :loading="addConfirmLoading">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		<a-modal  title="出库" width="40%" :visible="checkOutVisible"  @cancel="checkOutHandleCancel" @ok="checkOutHandleOk" :maskClosable="false" :keyboard="false">
			<div style="width: 100%;background-color: #fff;">
				<a-form-model ref="checkOutForm" :model="checkOutForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="checkOutRules">
					<a-form-model-item class="qa-table-item-3" label="出库数量" has-feedback prop="checkOutNum">
						<a-input v-model="checkOutForm.checkOutNum" :min="1" :max="addForm.surplus" :step="1" controls-position="right" ></a-input>
					</a-form-model-item>
				</a-form-model>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				pflibraryList: [],
				pfruleList: [],
				productList: [],
				pflibraryList2: [],
				pfruleList2: [],
				pfruleMap: {},
				productList2: [],
				priceList: [],
				staffList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					pfoutType:"2",
					facilitatorId: 0,
					pflibraryId: 0,
					productId: 0,
					optionStaffId: 0,
				},
				tableData: [],
				tableColumns: [
					// { title:'ID', dataIndex:'pfoutId', key:'pfoutId', align:'center' },
					{ title:'仓库名称', dataIndex:'pflibraryName', key:'pflibraryName', align:'center' },
					{ title:'门票名称', dataIndex:'productName', key:'productName', align:'center' },
					{ title:'价格', key:'listingPrice', align:'center', scopedSlots:{customRender:'listingPrice'} },
					{ title:'起始票号', key:'startSerial', align:'center', scopedSlots:{customRender:'startSerial'} },
					{ title:'截止票号', key:'endSerial', align:'center', scopedSlots:{customRender:'endSerial'} },
					{ title:'入库数量', dataIndex:'total', key:'total', align:'center' },
					{ title:'出库数量', dataIndex:'surplus', key:'surplus', align:'center' },
					{ title:'作废数量', dataIndex:'cancelNum', key:'cancelNum', align:'center' },
					{ title:'入库人', key:'staffName', align:'center', scopedSlots:{customRender:'staffName'}},
					{ title:'入库时间', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'} },
					{ title:'操作', key:'operator', align:'center', scopedSlots:{customRender:'operator'} },
				],
				tableLoading: false,
				tableSelectedRows: {},
				tableSelectedRowKeys:[], // 批量选中的key
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: undefined,
					pflibraryId: undefined,
					pfruleId: undefined,
					productId: undefined,
					priceId: undefined,
					optionStaffId: undefined,
					startSerial: '',
					endSerial: '',
					prefixCharacter: '',
					suffixCharacter: '',
					serialLength: '',
					total: 0,
					verifyState: 2,
					
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					pflibraryId: [{ required: true, message: '请选择仓库', trigger: 'blur' }],
					pfruleId: [{ required: true, message: '请选择票号规则', trigger: 'blur' }],
					productId: [{ required: true, message: '请选择产品', trigger: 'blur' }],
					priceId: [{ required: true, message: '请选择价格', trigger: 'blur' }],
					optionStaffId: [{ required: true, message: '请选择领取人', trigger: 'blur' }],
					startSerial: [{ required: true, message: '请输入起始票号', trigger: 'blur' }],
					total: [{ required: true, message: '请输入数量', trigger: 'blur' },
					{ pattern: /^[1-9]\d*$/, message: '请输入大于1的整数', trigger: 'blur' },
	
				],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					pfruleId: '',
					pfruleState: 3,
					remarks: '',
				},
				// 修改弹窗-end
				// 出库弹窗-start
				checkOutVisible: false,
				checkOutConfirmLoading: false,
				checkOutForm: {
					pfoutId: '',
					checkOutNum: 0,
				},
				checkOutRules: {
					checkOutNum: [
						{ required: true, message: '请输入出库数量', trigger: 'blur' },
						{ pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' },
					],
					
				},
				// 出库弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.apiPflibraryList(this.query.facilitatorId, 1)
					this.apiProductList(this.query.facilitatorId, 1)
					this.apiPfruleList(this.query.facilitatorId, 1)
					this.apiPfoutQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//根据服务商选择不同的仓库和门票
			facilitatorChange() {
				this.apiPflibraryList(this.query.facilitatorId, 1)
				this.apiProductList(this.query.facilitatorId, 1)
				this.apiPfruleList(this.query.facilitatorId, 1)
			},
			async apiPflibraryList(facilitatorId, type) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPflibraryList, {facilitatorId: facilitatorId});
				if (res.code == 200) {
					if(type == 1) {
						this.pflibraryList = res.data
					} else {
						this.pflibraryList2 = res.data
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiPfruleList(facilitatorId, type) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfruleList, {facilitatorId: facilitatorId});
				if (res.code == 200) {
					if(type == 1) {
						this.pfruleList = res.data
					} else {
						for(let i=0; i<res.data.length; i++) {
							this.pfruleMap['pfrule'+res.data[i].pfruleId] = res.data[i]
						}
						this.pfruleList2 = res.data
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiProductList(facilitatorId, type) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductList, {facilitatorId: facilitatorId});
				if (res.code == 200) {
					if(type == 1) {
						this.productList = res.data
					} else {
						this.productList2 = res.data
					}
					
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiPriceList(productId) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceList, {productId: productId});
				if (res.code == 200) {
					this.priceList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			async apiStaffList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.staffList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},

			//重置
			resetting() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 1,
					pflibraryId: 0,
					productId: 0,
					optionStaffId: 0,
					startTime: moment(),	
					endTime: moment(),
				}
			},
			//表格开始-搜索
			async apiPfoutQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutQueryList, this.query);
				if (res.code == 200) {
					console.log(res.data)
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
					this.tableSelectedRows = {}
					this.tableSelectedRowKeys = []
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPfoutQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPfoutQueryList()
			},
			//添加弹窗
			facilitatorChangeAdd() {
				this.addForm.pflibraryId = undefined
				this.addForm.pfruleId = undefined
				this.addForm.productId = undefined
				this.addForm.priceId = undefined
				this.addForm.optionStaffId = window.sessionStorage.getItem('staffId')
				this.addForm.prefixCharacter = '',
				this.addForm.suffixCharacter = '',
				this.priceList = []
				this.apiPflibraryList(this.addForm.facilitatorId, 2)
				this.apiProductList(this.addForm.facilitatorId, 2)
				this.apiPfruleList(this.addForm.facilitatorId, 2)
			},
			productChangeAdd() {
				this.addForm.priceId = undefined
				this.apiPriceList(this.addForm.productId)
			},
			addHandleCancel() {
				this.addVisible = false
			},
			pfruleChangeAdd() {
				console.log(this.pfruleMap['pfrule'+this.addForm.pfruleId])
				this.addForm.prefixCharacter = this.pfruleMap['pfrule'+this.addForm.pfruleId].prefixCharacter
				this.addForm.suffixCharacter = this.pfruleMap['pfrule'+this.addForm.pfruleId].suffixCharacter
				this.addForm.serialLength = this.pfruleMap['pfrule'+this.addForm.pfruleId].serialLength
				this.addForm.verifyState = this.pfruleMap['pfrule'+this.addForm.pfruleId].verifyState
			},
			//添加弹窗-格式化起始票号
			startSerialChangeAdd() {
				let dataLength = this.addForm.startSerial.length
				let serialLength = this.addForm.serialLength
				for(let i=0; i<(serialLength - dataLength); i++) {
					this.addForm.startSerial = '0' + this.addForm.startSerial
				}
				this.addForm.startSerial = this.addForm.startSerial.slice(this.addForm.startSerial.length - serialLength)
				this.totalChangeAdd()
			},
			totalChangeAdd() {
				if(this.addForm.startSerial.length > 0 && this.addForm.total > 0) {
					let endSerial = (parseInt(this.addForm.startSerial) + parseInt(this.addForm.total-1)).toString()
					let dataLength = endSerial.length
					let serialLength = this.addForm.serialLength
					
					for(let i=0; i<(serialLength - dataLength); i++) {
						endSerial = '0' + endSerial
					}
					this.addForm.endSerial = endSerial
				}
				
			},
			async apiPfoutAdd() {
				this.addConfirmLoading = true
				this.addForm.pfoutType = 2
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiPfoutQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPfoutAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			//修改弹窗事件-结束

			tableEdit() {
				if(this.tableSelectedRows.pfruleId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			checkOut(item){
				this.checkOutForm.pfoutId = item.pfoutId
				this.checkOutForm.checkOutNum = item.surplus
				this.checkOutVisible = true
			},
			async apiPfoutCheckOut(item) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutCheckOut, item);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.checkOutHandleCancel()
					this.apiPfoutQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			checkOutHandleCancel() {
				this.checkOutVisible = false
			},
			checkOutHandleOk() {
				this.$refs.checkOutForm.validate(valid => {
					if (valid) {
						this.apiPfoutCheckOut(this.checkOutForm)
					} else {
					  return false;
					  this.checkOutConfirmLoading = true
					}
				});
			},

			tableOut() {
				if(this.tableSelectedRows.pflibraryId > 0) {
					if(this.tableSelectedRows.surplus <= 0) {
						this.$message.warning('当前数量不足');
						return false;
					}
					this.checkOut(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			checkOutDetails(item) {
				if(item == undefined){
					if(!this.tableSelectedRows.pfoutId) {
						this.$message.warning('请选择要查看的数据');
						return
					}
					item = this.tableSelectedRows
				}
				let pfoutDetailsMain = []
				pfoutDetailsMain[0] = {'pflibraryName': item.pflibraryName}
				pfoutDetailsMain[1] = {'pfoutCheckInId': item.pfoutId, 'productName': item.productName, 'pfoutCheckOutId': 0}
				window.sessionStorage.setItem("pfoutDetailsMain", JSON.stringify(pfoutDetailsMain))
				this.$router.push('/PfoutDetails')
			},
			tableDelete(){
				if(!this.tableSelectedRows.pfoutId) {
					this.$message.warning('请选择要删除的数据');
					return
				}
				let _this = this
				const item = this.tableSelectedRows
				const content = '票号：' + item.prefixCharacter + item.startSerial + item.suffixCharacter + '至' + item.prefixCharacter + item.endSerial + item.suffixCharacter
				this.$confirm({
					title: '确定要删除当前选中数据吗',
					content: content,
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
						_this.apiPfoutDelete(item)
					},
					onCancel() {
						_this.$message.info('已取消删除');          
					},
				});
			},
			async apiPfoutDelete(item) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutDeleteCheckIn+'/'+item.pfoutId);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPfoutQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			
			
		},
		computed:{
			rowSelection() {
				let that = this
				// const { selectedRowKeys } = this
				return {
					type: 'radio',
					selectedRowKeys: that.tableSelectedRowKeys,
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0]
						that.tableSelectedRowKeys = selectedRowKeys
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
			this.apiStaffList()
		}
	};
</script>

<style scoped>
	
</style>
